import React from "react";
import { TwitterShareButton, TwitterIcon } from "react-share";
import { BASE_SHARE_TEXT, BASE_URL } from "../data";

interface Props {
  title?: string;
}

export const ShareTwitter = (props: Props) => {
  return (
    <TwitterShareButton url={BASE_URL} title={props.title || BASE_SHARE_TEXT}>
      <TwitterIcon size={32} round />
    </TwitterShareButton>
  );
};

export default ShareTwitter;
